import 'leaflet/dist/leaflet.css';
import styled, { ThemeProvider } from 'styled-components/macro';
import { Routes, Route } from 'react-router-dom';
import { Map } from './pages/Map';
import { hydrateModComponent, useMods } from './lib/mods';
import { Mods } from './pages/Mods';
import './App.css';
import { SideBar } from './components/sidebar';
import React from 'react';
import { Toaster } from 'react-hot-toast';

import backgroundImage from './img/bg-forest.jpg';
import { Console } from './pages/Console';
import { Context } from './lib/context';
import { useMemo } from 'react';
import { useState } from 'react';
import { AuthProvider } from './components/auth';
import { NotFound } from './pages/404';
import { Settings } from './pages/Settings';
import { Error } from './pages/Error';
import { Register } from './pages/Register';

const theme = {
  colors: {
    transparent: 'transparent',
    tfpRed: '#ff0000',
    tfpBlue: '#00A3E0',
    tfpLightGrey: '#CCCCCC',
    tfpDarkGrey: '#828383',
    tfpDarkGrey20: 'rgba(0,0,0, 0.2)',
    tfpDarkGrey40: 'rgba(0,0,0, 0.4)',
    tfpDarkGrey60: 'rgba(0,0,0, 0.6)',
    tfpDarkGrey80: 'rgba(0,0,0, 0.8)',
    tfpMediumGrey: '#C4C4C4',
    tfpBlack: '#090C0C',
    tfpWhite: '#FFFFFF',
  },
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.colors.tfpBlack};
  background-image: url(${backgroundImage});
  background-size: cover;
  color: ${(props) => props.theme.colors.tfpWhite};
`;

const ContentContainer = styled.div`
  min-width: ${(props) => (props.collapsed ? 'calc(100% - 100px)' : 'calc(100% - 250px)')};
  padding: 1%;
`;

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const mods = useMods();

  const modRoutes = [];

  if (mods) {
    mods.forEach((mod) => {
      for (const route in mod.external.routes) {
        if (Object.hasOwnProperty.call(mod.external.routes, route)) {
          const element = mod.external.routes[route];
          const sanitizedName = mod.name.toLowerCase().split(' ').join('');
          modRoutes.push({
            path: `mods/${sanitizedName}/${route}`,
            name: route,
            element: hydrateModComponent(element, { React }),
          });
        }
      }
    });
  }

  const [command, setCommand] = useState('help');
  const value = useMemo(() => ({ command, setCommand }), [command]);

  return (
    <div className="App">
      <AuthProvider>
        <Context.Provider value={value}>
          <ThemeProvider theme={theme}>
            <Toaster position="bottom-left" reverseOrder={true} />
            <PageContainer>
              <SideBar modRoutes={modRoutes} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
              <Routes>
                <Route
                  path="/"
                  element={
                    <ContentContainer collapsed={sidebarCollapsed}>
                      <Map />
                    </ContentContainer>
                  }
                />
                <Route
                  path="mods"
                  element={
                    <ContentContainer collapsed={sidebarCollapsed}>
                      <Mods />
                    </ContentContainer>
                  }
                />
                <Route
                  path="console"
                  element={
                    <ContentContainer collapsed={sidebarCollapsed}>
                      <Console />
                    </ContentContainer>
                  }
                />
                <Route
                  path="settings"
                  element={
                    <ContentContainer collapsed={sidebarCollapsed}>
                      <Settings />
                    </ContentContainer>
                  }
                />

                <Route path="createuser" element={<Register />} />

                {modRoutes.map((route) => {
                  return (
                    <Route
                      path={route.path}
                      element={<ContentContainer collapsed={sidebarCollapsed}>{route.element}</ContentContainer>}
                      key={route.path}
                    />
                  );
                })}

                <Route path="error/:code" element={<Error />} />

                <Route
                  path="*"
                  element={
                    <ContentContainer collapsed={sidebarCollapsed}>
                      <NotFound />
                    </ContentContainer>
                  }
                />
              </Routes>
            </PageContainer>
          </ThemeProvider>
        </Context.Provider>
      </AuthProvider>
    </div>
  );
}

export default App;
